/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import DisplayReleasePrice from '@components/tickets/release_card_price/DisplayReleasePrice'
import { Grid, useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { CommerceProductTaxMode } from '@ts/operations'
import { nanoid } from 'nanoid'
import React from 'react'

import { Theme } from '../../lib/theming/Theme'
import TicketVariantContext, { TicketVariant } from '../../lib/TicketVariantContext'
import { BenefitDescriptionItem, BenefitExpansionPanel, BenefitList } from '../benefits'
import PerforatedEdge from '../utils/PerforatedEdge'
import PromotedReleaseCard from './PromotedReleaseCard'
import { ProductProps } from './StoresSaleProductList'

export type StoresInfoPanelProps = {
  country: string
  currencySymbol: string
  displayPriceIncludingTax?: boolean
  heading?: string
  product?: ProductProps
  productId?: string
  showBenefits: boolean
}

const StoresInfoPanel = ({
  product,
  showBenefits,
  displayPriceIncludingTax = false,
  heading = 'Ticket type',
}: StoresInfoPanelProps) => {
  const theme = useTheme<Theme>()
  const mdUp = useMediaQuery(theme.breakpoints.up('md'))

  if (!product) {
    return null
  }

  const productPrice = product.price?.exTax.format
  const productBenefits = product?.tags
  const b2bProduct = product.taxMode === CommerceProductTaxMode.B2B
  const priceValue = productPrice ? (
    <DisplayReleasePrice
      displayPriceIncludingTax={b2bProduct ? false : displayPriceIncludingTax}
      displaySubPrice={!b2bProduct}
      price={product.price}
      variant="promoted"
    />
  ) : null

  const benefits = productBenefits?.map(benefit => (
    <BenefitDescriptionItem key={nanoid()} detail={benefit.description} title={benefit.name} />
  ))

  const BenefitsWrapper = mdUp ? BenefitList : BenefitExpansionPanel

  if (!product) return null

  return (
    <Grid container justify="center">
      <TicketVariantContext.Provider key={product.id} value={{ variant: TicketVariant.Promoted }}>
        <Grid item md sm={12} xs={12}>
          <PerforatedEdge borderRadius={theme.shape.borderRadius}>
            <PromotedReleaseCard
              description={product.description}
              name={product.name}
              price={priceValue}
              titleHeading={heading}
            />
          </PerforatedEdge>

          {showBenefits && <BenefitsWrapper>{benefits}</BenefitsWrapper>}
        </Grid>
      </TicketVariantContext.Provider>
    </Grid>
  )
}

export default StoresInfoPanel
